import $ from 'jquery';
import * as bootstrap from 'bootstrap';
import Swal from 'sweetalert2';

export function initLaporanCallback() {
  const $table = $('#table-laporan-callback');
  if (!$table.length) return;

  const rawBaseUrl = $('#page-id').data('base-url') || '';
  const baseUrl = rawBaseUrl.replace(/\/+$/, '');

  // 1. Initialize DataTable
  const callbackTable = $table.DataTable({
    processing: false,
    serverSide: true,
    ajax: {
      url: `${baseUrl}/laporan-callback/ajax-datatable`,
      type: 'GET',
      data: function (d) {
        const formParams = $('#filterForm').serializeArray();
        formParams.forEach((item) => {
          if (item.value) {
            if (d[item.name]) {
              if (!Array.isArray(d[item.name])) {
                d[item.name] = [d[item.name]];
              }
              d[item.name].push(item.value);
            } else {
              d[item.name] = item.value;
            }
          }
        });
      },
    },
    columns: [
      { data: 'no', orderable: false, searchable: false, className: 'text-center' },
      { data: 'action', orderable: false, searchable: false, className: 'text-center' },
      { data: 'no_lapor' },
      { data: 'nama_up3' },
      { data: 'nama_ulp' },
      { data: 'tgl_jam_response' },
      { data: 'durasi_response_time' },
      { data: 'idpel_idmeter' },
      { data: 'nama_pelapor' },
      { data: 'alamat_pelapor' },
      { data: 'no_telp_pelapor' },
      { data: 'waktu_callback_jam' },
      { data: 'waktu_callback_tgl' },
      { data: 'keterangan_laporan' },
      { data: 'sumber_lapor' },
      { data: 'status', className: 'text-center' },
      { data: 'foto', orderable: false, searchable: false, className: 'text-center' },
    ],
    order: [[5, 'desc']],
    autoWidth: false,
    dom: "t<'row mt-4 align-items-center'<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0'i><'col-sm-12 col-md-7 d-flex justify-content-center justify-content-md-end'p>>",
    language: {
      search: '',
      lengthMenu: '_MENU_',
      loadingRecords: '',
      info: "<span class='text-muted fw-medium small'>Menampilkan <b class='text-dark'>_START_-_END_</b> dari <b class='text-dark'>_TOTAL_</b></span>",
      infoEmpty: "<span class='text-muted small'>Menampilkan 0 data</span>",
      infoFiltered: "<span class='text-muted small'>(disaring dari _MAX_ data)</span>",
      emptyTable:
        "<div class='text-center py-5 text-muted'><i class='bi bi-inbox fs-4 d-block mb-2'></i>Belum ada data Laporan Callback</div>",
      zeroRecords:
        "<div class='text-center py-5 text-muted'><i class='bi bi-search fs-4 d-block mb-2'></i>Pencarian tidak ditemukan</div>",
      paginate: { previous: 'Sebelumnya', next: 'Berikutnya' },
    },
    pageLength: 50,
  });

  // Keep loader cleanly inside table body
  $table.on('preXhr.dt', function () {
    $table.find('tbody').html(`
      <tr>
        <td colspan="17" class="text-center py-5">
          <div class="spinner-border text-primary" role="status" style="width: 2rem; height: 2rem; border-width: 0.15em;"></div>
          <div class="mt-2 text-muted small">Memuat data...</div>
        </td>
      </tr>
    `);
  });

  window.callbackTable = callbackTable;

  // 2. Connect custom Show & Search controls
  $('#customLengthMenu').on('change', function () {
    callbackTable.page.len(parseInt($(this).val())).draw();
  });
  let searchTimer;
  $('#customSearchInput').on('input', function () {
    const val = $(this).val();
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => callbackTable.search(val).draw(), 300);
  });

  // 3. Handle Filter Form
  $('#filterForm').on('submit', function (e) {
    e.preventDefault();
    callbackTable.ajax.reload();
    updateExportUrls();
  });

  $('#resetFilterBtn').on('click', function () {
    $('#filterForm')[0].reset();
    $('#filterForm select').val(null).trigger('change');
    callbackTable.ajax.reload();
    updateExportUrls();
  });

  function updateExportUrls() {
    const params = $('#filterForm').serialize();
    const query = params ? '?' + params : '';
    $('#btnExportExcel')
      .attr('data-url-init', `${baseUrl}/laporan-callback/init-export${query}`)
      .attr('data-url-chunk', `${baseUrl}/laporan-callback/export-chunk${query}`)
      .attr('data-url-download', `${baseUrl}/laporan-callback/download-export`);
  }

  // 4. Reset on Tambah Button
  $('#btn-tambah').on('click', function () {
    $('#id_laporan').val('');
    $('#formTambah')[0].reset();
    $('#formTambah select').val('').trigger('change');
    $('#foto').prop('required', true);
    $('#foto-required-star').removeClass('d-none');
    $('#foto-preview').empty();
    $('#modalTambahLabel').html('<i class="bi bi-plus-circle me-2"></i>Tambah Laporan Callback');
  });

  // 5. Form Submit (Tambah & Edit)
  $('#formTambah').on('submit', function (e) {
    e.preventDefault();
    const form = this;
    const formData = new FormData(form);
    const id = $('#id_laporan').val();
    const url = id
      ? `${baseUrl}/laporan-callback/update/${id}`
      : `${baseUrl}/laporan-callback/store`;
    const $btn = $('#btnSimpan');
    $btn.prop('disabled', true).find('.spinner-border').removeClass('d-none');

    $.ajax({
      url: url,
      type: 'POST',
      data: formData,
      processData: false,
      contentType: false,
      success: function (res) {
        if (res.status === 'success') {
          Swal.fire({
            icon: 'success',
            title: 'Berhasil',
            text: res.message,
            timer: 1500,
            showConfirmButton: false,
          });
          const modalEl = document.getElementById('modalTambah');
          const modal = bootstrap.Modal.getInstance(modalEl);
          if (modal) modal.hide();
          form.reset();
          $('#id_laporan').val('');
          $('#foto-preview').empty();
          callbackTable.ajax.reload();
        } else {
          let errMsg = res.message || 'Terjadi kesalahan.';
          if (res.errors) {
            errMsg = Object.values(res.errors).join('<br>');
          }
          Swal.fire({
            icon: 'error',
            title: 'Gagal',
            html: errMsg,
          });
        }
      },
      error: function (xhr) {
        Swal.fire({
          icon: 'error',
          title: 'Kesalahan Sistem',
          text: xhr.responseJSON?.message || 'Terjadi kesalahan pada server.',
        });
      },
      complete: function () {
        $btn.prop('disabled', false).find('.spinner-border').addClass('d-none');
      },
    });
  });

  // 6. View Detail Handler
  $(document).on('click', '.btn-view-detail', function () {
    const id = $(this).attr('data-id');
    $('#detail_no_lapor').text('Memuat...');
    $('#detailContent').html(`
      <div class="text-center py-5">
        <div class="spinner-border text-primary" role="status" style="width: 2.5rem; height: 2.5rem;"></div>
        <p class="mt-3 text-muted small">Memuat detail laporan callback...</p>
      </div>
    `);

    const modalDetailEl = document.getElementById('modalDetail');
    const modalDetail = bootstrap.Modal.getOrCreateInstance(modalDetailEl);
    modalDetail.show();

    $.ajax({
      url: `${baseUrl}/laporan-callback/detail/${id}/json`,
      type: 'GET',
      dataType: 'json',
      success: function (res) {
        if (res.status === 'success') {
          const d = res.data;
          $('#detail_no_lapor').text(d.no_lapor || '-');

          const statusBadge =
            d.status === 'Selesai'
              ? '<span class="badge rounded-pill bg-success-subtle text-success border border-success-subtle px-3 py-1 fw-bold">Selesai</span>'
              : `<span class="badge rounded-pill bg-warning-subtle text-warning-emphasis border border-warning-subtle px-3 py-1 fw-bold">${d.status || 'Belum Selesai'}</span>`;

          const fotoHtml = d.foto
            ? `<div class="text-center">
                 <a href="${baseUrl}/laporan-callback/image/${d.foto}" target="_blank" title="Klik untuk membuka foto asli">
                   <img src="${baseUrl}/laporan-callback/image/${d.foto}" alt="Foto Eviden" class="img-fluid rounded-3 shadow-sm border mb-3" style="max-height: 280px; object-fit: contain;">
                 </a>
                 <div>
                   <a href="${baseUrl}/laporan-callback/image/${d.foto}" target="_blank" class="btn btn-sm btn-outline-primary rounded-pill px-3 shadow-sm">
                     <i class="bi bi-box-arrow-up-right me-1"></i> Buka Foto Asli
                   </a>
                 </div>
               </div>`
            : `<div class="d-flex flex-column align-items-center justify-content-center p-4 text-muted bg-white border rounded-3" style="min-height: 180px;">
                 <i class="bi bi-image fs-1 mb-2 text-secondary opacity-50"></i>
                 <span class="small fst-italic">Tidak ada foto eviden terlampir</span>
               </div>`;

          const tglJamResponse = d.tgl_jam_response
            ? new Date(d.tgl_jam_response).toLocaleString('id-ID', {
                dateStyle: 'medium',
                timeStyle: 'short',
              })
            : '-';

          const waktuCallbackTgl = d.waktu_callback_tgl
            ? new Date(d.waktu_callback_tgl).toLocaleDateString('id-ID', { dateStyle: 'medium' })
            : '-';

          let html = `
            <div class="row g-4">
              <!-- Card 1: Informasi Laporan -->
              <div class="col-lg-4">
                <div class="card border-0 bg-light rounded-4 h-100 shadow-none">
                  <div class="card-body p-4">
                    <h6 class="text-dark small fw-bold text-uppercase ls-wide mb-3 d-flex align-items-center gap-2">
                      Informasi Laporan
                    </h6>
                    <div class="mb-3">
                      <label class="text-dark small d-block mb-1">No. Lapor</label>
                      <span class="fw-bold text-dark fs-6">${d.no_lapor || '-'}</span>
                    </div>
                    <div class="mb-3">
                      <label class="text-dark small d-block mb-1">Unit (UP3 / ULP)</label>
                      <span class="fw-semibold text-dark">${d.nama_up3 || '-'}</span>
                      <div class="small text-dark">${d.nama_ulp || '-'}</div>
                    </div>
                    <div class="mb-3">
                      <label class="text-dark small d-block mb-1">Sumber Lapor</label>
                      <span class="fw-semibold text-dark">${d.sumber_lapor || '-'}</span>
                    </div>
                    <div class="mb-3">
                      <label class="text-dark small d-block mb-1">Status</label>
                      <div>${statusBadge}</div>
                    </div>
                    <div class="mb-0">
                      <label class="text-dark small d-block mb-1">Keterangan Laporan</label>
                      <div class="small text-dark p-2 bg-white rounded-3 border">${d.keterangan_laporan || '-'}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Card 2: Data Pelapor -->
              <div class="col-lg-4">
                <div class="card border-0 bg-light rounded-4 h-100 shadow-none">
                  <div class="card-body p-4">
                    <h6 class="text-dark small fw-bold text-uppercase ls-wide mb-3 d-flex align-items-center gap-2">
                      Data Pelapor
                    </h6>
                    <div class="mb-3">
                      <label class="text-dark small d-block mb-1">Nama Pelapor</label>
                      <span class="fw-bold text-dark">${d.nama_pelapor || '-'}</span>
                    </div>
                    <div class="mb-3">
                      <label class="text-dark small d-block mb-1">IDPEL / IDMETER</label>
                      <div><span class="badge bg-light text-dark border border-dark-subtle px-2 py-1">${d.idpel_idmeter || '-'}</span></div>
                    </div>
                    <div class="mb-3">
                      <label class="text-dark small d-block mb-1">No. Telp Pelapor</label>
                      <span class="fw-semibold text-dark">
                        ${d.no_telp_pelapor || '-'}
                      </span>
                    </div>
                    <div class="mb-0">
                      <label class="text-dark small d-block mb-1">Alamat Pelapor</label>
                      <div class="small text-dark p-2 bg-white rounded-3 border">${d.alamat_pelapor || '-'}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Card 3: Waktu & Response -->
              <div class="col-lg-4">
                <div class="card border-0 bg-light rounded-4 h-100 shadow-none">
                  <div class="card-body p-4">
                    <h6 class="text-dark small fw-bold text-uppercase ls-wide mb-3 d-flex align-items-center gap-2">
                      Waktu & Response
                    </h6>
                    <div class="mb-3">
                      <label class="text-dark small d-block mb-1">Tgl / Jam Response</label>
                      <span class="fw-semibold text-dark">${tglJamResponse}</span>
                    </div>
                    <div class="mb-3">
                      <label class="text-dark small d-block mb-1">Durasi Response Time</label>
                      <span class="fw-bold text-dark">${d.durasi_response_time || '-'}</span>
                    </div>
                    <div class="mb-3">
                      <label class="text-dark small d-block mb-1">Waktu Callback (Hari/Tgl)</label>
                      <span class="fw-semibold text-dark">${waktuCallbackTgl}</span>
                    </div>
                    <div class="mb-0">
                      <label class="text-dark small d-block mb-1">Waktu Callback (Jam)</label>
                      <span class="fw-semibold text-dark">${d.waktu_callback_jam || '-'}</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Card 4: Foto Eviden Callback -->
              <div class="col-12 mt-2">
                <div class="card border-0 bg-light rounded-4 shadow-none">
                  <div class="card-body p-4">
                    <h6 class="text-dark small fw-bold text-uppercase ls-wide mb-3 d-flex align-items-center gap-2">
                      Foto Eviden Callback
                    </h6>
                    ${fotoHtml}
                  </div>
                </div>
              </div>
            </div>
          `;
          $('#detailContent').html(html);
        } else {
          $('#detailContent').html(`
            <div class="alert alert-danger mb-0" role="alert">
              <i class="bi bi-exclamation-triangle me-2"></i> ${res.message || 'Gagal memuat detail laporan.'}
            </div>
          `);
        }
      },
      error: function () {
        $('#detailContent').html(`
          <div class="alert alert-danger mb-0" role="alert">
            <i class="bi bi-exclamation-triangle me-2"></i> Terjadi kesalahan pada server saat memuat detail data.
          </div>
        `);
      },
    });
  });

  // 7. Edit Handler
  $(document).on('click', '.btn-edit', function () {
    const id = $(this).attr('data-id'); // encrypted ID string
    $.ajax({
      url: `${baseUrl}/laporan-callback/edit/${id}/json`,
      type: 'GET',
      dataType: 'json',
      success: function (res) {
        if (res.status === 'success') {
          const d = res.data;
          // Use the encrypted ID from the button for form update URL
          $('#id_laporan').val(id);
          $('#no_lapor').val(d.no_lapor);

          const up3Val = d.id_up3_encrypted || d.id_up3;
          const ulpVal = d.id_ulp_encrypted || d.id_ulp;

          $('#id_up3').val(up3Val).trigger('change');
          $('#id_ulp').one('cascadingComplete', function () {
            $('#id_ulp').val(ulpVal).trigger('change');
          });
          setTimeout(() => {
            if (!$('#id_ulp').val() && ulpVal) {
              $('#id_ulp').val(ulpVal).trigger('change');
            }
          }, 300);

          $('#tgl_jam_response').val(
            d.tgl_jam_response ? d.tgl_jam_response.replace(' ', 'T') : ''
          );
          $('#durasi_response_time').val(d.durasi_response_time);
          $('#idpel_idmeter').val(d.idpel_idmeter);
          $('#nama_pelapor').val(d.nama_pelapor);
          $('#alamat_pelapor').val(d.alamat_pelapor);
          $('#no_telp_pelapor').val(d.no_telp_pelapor);
          $('#waktu_callback_jam').val(d.waktu_callback_jam);
          $('#waktu_callback_tgl').val(d.waktu_callback_tgl);
          $('#keterangan_laporan').val(d.keterangan_laporan);
          $('#sumber_lapor').val(d.sumber_lapor);
          $('#status').val(d.status).trigger('change');

          // On edit, photo is optional because old photo can be retained
          $('#foto').prop('required', false);
          $('#foto-required-star').addClass('d-none');

          if (d.foto) {
            $('#foto-preview').html(
              `<a href="${baseUrl}/laporan-callback/image/${d.foto}" target="_blank" class="small text-primary"><i class="bi bi-image me-1"></i>Lihat Foto Saat Ini</a>`
            );
          } else {
            $('#foto-preview').empty();
          }

          $('#modalTambahLabel').html(
            '<i class="bi bi-pencil-square me-2"></i>Edit Laporan Callback'
          );
          const modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('modalTambah'));
          modal.show();
        }
      },
    });
  });

  // 8. Delete Handler
  $(document).on('click', '.btn-delete', function () {
    const id = $(this).attr('data-id');
    Swal.fire({
      title: 'Hapus Laporan Callback?',
      text: 'Data yang dihapus tidak dapat dikembalikan!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Ya, Hapus!',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        $.ajax({
          url: `${baseUrl}/laporan-callback/delete/${id}`,
          type: 'POST',
          dataType: 'json',
          success: function (res) {
            if (res.status === 'success') {
              Swal.fire({
                icon: 'success',
                title: 'Terhapus!',
                text: res.message,
                timer: 1500,
                showConfirmButton: false,
              });
              callbackTable.ajax.reload();
            } else {
              Swal.fire('Gagal!', res.message, 'error');
            }
          },
        });
      }
    });
  });

  // Reset modal on hide
  $('#modalTambah').on('hidden.bs.modal', function () {
    $('#formTambah')[0].reset();
    $('#id_laporan').val('');
    $('#formTambah select').val('').trigger('change');
    $('#foto').prop('required', true);
    $('#foto-required-star').removeClass('d-none');
    $('#foto-preview').empty();
    $('#modalTambahLabel').html('<i class="bi bi-plus-circle me-2"></i>Tambah Laporan Callback');
  });
}
